/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled from 'styled-components';

export const RightCustomInputStyle = {
  borderRadius: 0,
  '&.Mui-focused': {
    borderRadius: '0',
  },
};

export const LeftCustomInputStyle = {
  borderRadius: '4px 0 0 4px',
  '&.Mui-focused': {
    borderRadius: '4px 0 0 4px',
  },
};
